import { AI_COACH_CONTENT_FETCH_ENDED } from '../../types';
export const setAiCoachContentData = _ref => {
  let {
    content,
    derivedCourseContentId,
    exerciseId
  } = _ref;
  return {
    content,
    derivedCourseContentId,
    exerciseId,
    type: AI_COACH_CONTENT_FETCH_ENDED
  };
};